export const EMAIL_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "unread", label: "Unread" },
  { value: "sent", label: "Sent" },
] as const;

export const EMAIL_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export const EMAIL_MAILBOX_OPTIONS = [
  { value: "all", label: "All mailboxes" },
  { value: "support", label: "Support" },
  { value: "clinical", label: "Clinical" },
  { value: "billing", label: "Billing" },
] as const;

export type EmailToolbarTab = (typeof EMAIL_TAB_ITEMS)[number]["value"];
export type EmailPeriodFilter = (typeof EMAIL_PERIOD_OPTIONS)[number]["value"];
export type EmailMailboxFilter = (typeof EMAIL_MAILBOX_OPTIONS)[number]["value"];
